import { useCallback } from 'react';

import { useTrackAgentPanelOpened } from '@air/analytics';
import { type Board } from '@air/api/types';

import { useIsWorkspaceAgentPanelAvailable } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useIsWorkspaceAgentPanelAvailable';
import { useWorkspaceAgentCreditsDepleted } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentCreditsDepleted';
import { useWorkspaceAgentPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';

export const useLaunchBoardTemplatesInWorkspaceAgent = () => {
  const { isWorkspaceAgentPanelAvailable } = useIsWorkspaceAgentPanelAvailable();
  const dock = useWorkspaceAgentPanelStore((state) => state.dock);
  const startNewThreadWithBoardTemplates = useWorkspaceAgentPanelStore(
    (state) => state.startNewThreadWithBoardTemplates,
  );
  const showChat = useWorkspaceAgentPanelStore((state) => state.showChat);
  const { blockIfCreditsDepleted } = useWorkspaceAgentCreditsDepleted();
  const { trackAgentPanelOpened } = useTrackAgentPanelOpened();

  const launchBoardTemplatesInAgent = useCallback(
    (board: Pick<Board, 'id' | 'title' | 'workspaceId'>) => {
      if (blockIfCreditsDepleted(() => showChat({ focusComposer: false }))) {
        return;
      }

      const wasMinimized = dock === 'minimized';

      startNewThreadWithBoardTemplates('board_menu', {
        id: board.id,
        title: board.title,
        workspaceId: board.workspaceId,
      });

      if (wasMinimized) {
        trackAgentPanelOpened({ location: 'board_menu' });
      }
    },
    [blockIfCreditsDepleted, dock, showChat, startNewThreadWithBoardTemplates, trackAgentPanelOpened],
  );

  return { canLaunchBoardTemplatesInAgent: isWorkspaceAgentPanelAvailable, launchBoardTemplatesInAgent };
};
